module.exports = __webpack_public_path__ + "img/banner3_3.98614b9a.png";